<template>
    <a-modal v-bind:open="computedShowModal"
    width="720px"
    :closable="true"
    :footer="null"
    :mask-closable="true"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    :title="$t('productslist_view_product')"
    :centered="true"
    @cancel="closeModal"
    >
        <div class="modal-content-body">
            <div class="modal-input-area"  v-if="productDetailData.itemCode">
                <div class="label-wrap">
                    <i class="fa-solid fa-barcode-read"/>
                    <label>{{ $t('productslist_item_code') }}
                    </label>
                </div>
                <a-input
                    disabled
                    v-model:value="computedItemCode"
                />
            </div>
            <div class="modal-input-area" v-if="productDetailData.productCode">
                <div class="label-wrap">
                    <i class="fa-solid fa-barcode-read"/>
                    <label>{{ $t('productslist_table_code') }}
                    </label>
                </div>
                <a-input
                    disabled
                    v-model:value="productDetailData.productCode" 
                    :placeholder="$t('productslist_productcode_placeholder')" 
                />
            </div>
            <div class="modal-input-area align-items-start"  v-if="productDetailData.description">
                <div class="label-wrap label-wrap-align-top">
                    <i class="fa-light fa-message-lines"/>
                    <label>{{ $t('productslist_desc') }}</label>
                </div>
                <a-textarea 
                    disabled
                    v-model:value="productDetailData.description" 
                    :placeholder="$t('productslist_description_placeholder')"
                />
            </div>
            <div class="modal-input-area align-items-start"  v-if="productDetailData.jsonContents">
                <div class="label-wrap label-wrap-align-top">
                    <i class="fa-regular fa-cube"/>
                    <label>{{ $t('itemslist_props') }}</label>
                </div>
                <div class="props-wrap">
                    <div class="prop" v-for="(item, i) in productDetailData.jsonContents" :key="i">
                        <div class="json-key">
                            <a-input
                                v-model:value="item.propertyName"
                                disabled
                            />
                        </div>
                        <div class="json-value">
                            <a-input
                                v-model:value="item.propertyValue"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <a-button
                @click="closeModal"
            >
                {{ $t('common_close') }}
            </a-button>
        </div>
    </a-modal>
</template>
<script>
    import { oneBtnDialog } from '@/utils/utils'
    import { modalType } from '../enums/enums';

    export default {
        props: {
            showModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            id: {
                type: String,
                reqiured: true,
                default: '',
            },
        },
        data() {
            return {
                productDetailData: {
                    itemName: '',
                    itemCode: '',
                    itemNo: '',
                    description: '',
                    productId: '',
                    productCode: '',
                    jsonContents: [],
                },
            }
        },
        emits: ['closeModal',],
        computed: {
            computedShowModal() {
                return this.showModal;
            },
            computedItemCode() {
                return `${this.productDetailData.itemName} / ${this.productDetailData.itemCode}`
            },
        },
        watch: {
            computedShowModal: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if(newValue) {
                        this.getProductDetail(this.id);
                    }
                },
            },
        },
        methods: {
            closeModal() {
                this.$emit('closeModal', modalType.read, false);
                this.initData();
            },
            initData() {
                this.selectedItem = undefined;
                this.itemsList = [];
                this.itemName = '';
                this.itemCode = '';
                this.itemNo = '';
                this.description = '';
                this.productId = '';
                this.productCode = '';
                this.jsonContents = [];
            },
            async getProductDetail(productId) {
                try {
                    const response = await this.$apiInstance.get(`/products/${productId}`);
                    if (response.status === 200 || response.status === 201) {
                    this.productDetailData = response.data;
                    this.productDetailData.productId = productId;
                        if (!response.data.jsonContents) return;

                        const jsonContents = JSON.parse(response.data.jsonContents);
                        const array = [];
                        if(jsonContents.length > 0) {
                            jsonContents.forEach((element) => {
                                const propertyObj = {
                                    propertyName: Object.keys(element)[0],
                                    propertyValue: Object.values(element)[0],
                                };
                                array.push(propertyObj);
                            })
                            this.productDetailData.jsonContents = array;
                        }
                    }
                } catch (error) {
                    console.log(error);
                    oneBtnDialog(this.$i18n.t('productslist_single_load_err_title'), this.$i18n.t('productslist_single_load_err_content'), false);
                }
            },
            initProductDetailData() {
                this.productDetailData.itemName = '';
                this.productDetailData.itemCode = '';
                this.productDetailData.itemNo = '';
                this.productDetailData.description = '';
                this.productDetailData.productId = '';
                this.productDetailData.productCode = '';
                this.productDetailData.jsonContents = [];
            },
        },
    };
</script>
<style lang="scss" scoped>

$Gray-10: #F3F5F6;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$CertiLifeYellow: #ffe414;

.modal-content-body {
    padding: 20px;
}

.modal-input-area {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 7px 0;
    width: 100%;

    .content-part {
        width: 80%;
    }

    .label-wrap {
        display: flex;
        align-items: center;
        width: 20%;
        // margin: 0 10px 0 0;
        i {
            margin-right: 5px;
            color: rgb(75, 81, 88);
            font-size: 15px;
        }

        label {
            margin-bottom: 0 !important;
            color: rgb(75, 81, 88);
            font-size: 15px;
            font-weight: 500;
            text-align: start;
            display: flex;
            .required-span {
                width: 6px;
                height: 6px;
                border-radius: 100%;
                background-color: #FB574B;
                margin-left: 3px;
                display: block;
                margin-top: 2px;
            }
        }
    }

    .label-wrap-align-top {
        padding-top: 15px !important;
    }

    select {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
    }

    textarea {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 100px;
        resize: none;
        padding: 7px 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    // 제품정보보기
    .props-wrap {
        width: 80%;
    }

    .prop {
        width: 100%; 
        display: flex;
    }

    .json-key {
        display:flex;
        flex-direction: column; 
        margin-right: 2.5%; 
        width: 47.5%;
    }

    .json-value {
        display:flex;
        flex-direction: column; 
        margin-left: 2.5%; 
        width: 47.5%;
    }

    input[type=text],
    input[type=password] {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
        padding: 0 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    input[type=checkbox] {
        accent-color: #ffd814;
        width: 10px;
    }

    div {
        input[type="text"] {
            width: 100%;
            margin-top: 5px;
            border-radius: 6px;
        }

        button {
            background-color: #FFD814;
            padding: 5px 10px;
            border: none;
            border-radius: 8px;
            font-weight: bold;
            font-size: 0.8rem;
            float: right;
        }
    }
}

select {
    width: 100%;
}

.modal-input-area:last-child {
    padding: 7px 0 0 0;
}

.modal-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px 20px;
    // padding: 20px;
    gap: 10px;
    .button {
        border-radius: 0px;
        color: $Gray-90;
    }
}
</style>